export default __webpack_public_path__ + "static/media/690.02be745e.gif";